module.exports = __webpack_public_path__ + "img/dislike.a8a4e164.svg";